// Sacred Geometry SVG Components for each numerology frequency (1-9)

const SacredGeometry = ({ frequency, size = 80, className = "" }) => {
  const commonProps = {
    width: size,
    height: size,
    viewBox: "0 0 100 100",
    className: className
  };

  const geometryComponents = {
    1: ( // Monade - Point central
      <svg {...commonProps}>
        <circle cx="50" cy="50" r="25" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="50" cy="50" r="8" fill="currentColor" />
      </svg>
    ),
    
    2: ( // Vesica Piscis - Dualité
      <svg {...commonProps}>
        <circle cx="35" cy="50" r="25" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="65" cy="50" r="25" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M 50 25 A 25 25 0 0 1 50 75 A 25 25 0 0 1 50 25" fill="currentColor" opacity="0.3" />
      </svg>
    ),
    
    3: ( // Triangle - Trinité
      <svg {...commonProps}>
        <path d="M 50 15 L 85 75 L 15 75 Z" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="50" cy="15" r="4" fill="currentColor" />
        <circle cx="85" cy="75" r="4" fill="currentColor" />
        <circle cx="15" cy="75" r="4" fill="currentColor" />
        <circle cx="50" cy="55" r="3" fill="currentColor" />
      </svg>
    ),
    
    4: ( // Carré - Stabilité
      <svg {...commonProps}>
        <rect x="20" y="20" width="60" height="60" fill="none" stroke="currentColor" strokeWidth="2" />
        <line x1="20" y1="50" x2="80" y2="50" stroke="currentColor" strokeWidth="1.5" />
        <line x1="50" y1="20" x2="50" y2="80" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="50" r="6" fill="currentColor" />
      </svg>
    ),
    
    5: ( // Pentagramme
      <svg {...commonProps}>
        <path d="M 50 10 L 59 38 L 88 38 L 65 55 L 74 83 L 50 66 L 26 83 L 35 55 L 12 38 L 41 38 Z" 
              fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="50" cy="10" r="3" fill="currentColor" />
        <circle cx="88" cy="38" r="3" fill="currentColor" />
        <circle cx="74" cy="83" r="3" fill="currentColor" />
        <circle cx="26" cy="83" r="3" fill="currentColor" />
        <circle cx="12" cy="38" r="3" fill="currentColor" />
      </svg>
    ),
    
    6: ( // Hexagone / Graine de vie
      <svg {...commonProps}>
        <circle cx="50" cy="50" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="30" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="67" cy="40" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="67" cy="60" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="70" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="33" cy="60" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="33" cy="40" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
    
    7: ( // Fleur de vie (simplifiée)
      <svg {...commonProps}>
        <circle cx="50" cy="50" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="32" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="68" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="66" cy="41" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="66" cy="59" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="34" cy="41" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="34" cy="59" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="50" r="25" fill="none" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
    
    8: ( // Octogone / Étoile à 8 branches
      <svg {...commonProps}>
        <path d="M 50 10 L 71 29 L 90 50 L 71 71 L 50 90 L 29 71 L 10 50 L 29 29 Z" 
              fill="none" stroke="currentColor" strokeWidth="2" />
        <line x1="50" y1="10" x2="50" y2="90" stroke="currentColor" strokeWidth="1" />
        <line x1="10" y1="50" x2="90" y2="50" stroke="currentColor" strokeWidth="1" />
        <line x1="29" y1="29" x2="71" y2="71" stroke="currentColor" strokeWidth="1" />
        <line x1="71" y1="29" x2="29" y2="71" stroke="currentColor" strokeWidth="1" />
        <circle cx="50" cy="50" r="8" fill="currentColor" />
      </svg>
    ),
    
    9: ( // Fruit de vie / Ennéagone
      <svg {...commonProps}>
        <circle cx="50" cy="50" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="28" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="72" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="67" cy="36" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="67" cy="64" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="33" cy="36" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="33" cy="64" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="72" cy="50" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="28" cy="50" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="50" cy="50" r="30" fill="none" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  };

  return geometryComponents[frequency] || geometryComponents[1];
};

export default SacredGeometry;
